import { atom } from 'recoil';

const pitchState = atom({
    key: 'pitch',
    default: null
});

export default pitchState;
